<template>
  <header class="items-center py-2 mx-auto max-w-screen-xl">
    <div
      class="gap-6 items-center py-8 px-4 mx-auto max-w-screen-xl flex flex-col text-center justify-center lg:py-16 lg:px-6"
    >
      <div class="font-light text-gray-500 sm:text-lg">
        <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">
          Vorverkauf - Tickets sichern!
        </h2>
        <p class="mb-4">
          Bei unserem Vorverkauf können Sie Tickets vorbestellen und sich damit
          einen Platz in unseren legendären Vorstellungen sichern. Diese Tickets
          müssen min. {{ presaleMinutesBeforePerformance }} Minuten vor
          Vorstellungsbeginn an der Kasse abgeholt werden. Zusätzlich halten wir
          allerdings auch Tickets an der Tageskasse für Sie bereit. Sollten Sie
          auf einen Rollstuhl angewiesen sein, bitten wir Sie uns zu
          kontaktieren, damit wir die nötigen Vorbereitungen treffen können. Wir
          freuen uns auf Ihren Besuch!
        </p>
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>
const { presaleMinutesBeforePerformance } = useRuntimeConfig().public;
</script>
